import React, { Suspense, lazy } from "react";
import { Route } from "react-router-dom";
import { filterRoutes } from "../utils/moduleAccessUtils";
import { getItem } from "../utils/localStorageUtils";
import { Backdrop, LogoLoader } from "../components";
const AtsDashboard = lazy(() => import("../pages/Ats/AtsDashboard"));
const Help = lazy(() => import("../pages/Ats/Help/Help"));
const TicketDetail = lazy(
  () => import("../pages/Ats/Help/HelpTabs/TicketDetails/TicketDetails"),
);
const Recruiters = lazy(
  () => import("../pages/BenchSales/Recruiters/Recruiters"),
);
const Interview = lazy(
  () => import("../pages/BenchSales/Interviews/Interviews"),
);
const Submissions = lazy(
  () => import("../pages/BenchSales/Submissions/Submissions"),
);
const Placement = lazy(
  () => import("../pages/BenchSales/Placements/Placements"),
);

const CandidatesAddNewCandidate = lazy(
  () => import("../pages/BenchSales/Jobs/CandidatesAddNewCandidate"),
);
const Candidates = lazy(
  () => import("../pages/BenchSales/Candidates/Candidates"),
);
const JobsBenchsales = lazy(
  () => import("../pages/BenchSales/Jobs/JobsBenchsales"),
);
const InnerMainLayoutBs = lazy(
  () => import("../pages/BenchSales/_layout/InnerMainLayoutBs"),
);
const BenchSalesDashboard = lazy(
  () => import("../pages/BenchSales/BenchSalesDashboard"),
);
const Templates = lazy(() => import("../pages/BenchSales/Templates/Templates"));
const ResumeTemplate = lazy(
  () => import("../pages/BenchSales/Templates/TemplateTabs/ResumeTemplate"),
);
const Reports = lazy(() => import("../pages/BenchSales/BsReports/Reports"));
const Hotlist = lazy(() => import("../pages/BenchSales/Hotlist/Hotlist"));
const PushDataToWorkforceBs = lazy(
  () => import("../pages/BenchSales/Placements/PushDataToWorkforceBs"),
);
const Mails = lazy(() => import("../pages/BenchSales/Mails/Mail"));

const BsRoutes = ({ moduleAccess = {}, user = {} }) => {
  const loginUserData = user?.data || {};
  const portal = getItem("portal");
  const role = loginUserData?.role?.type ?? null;
  const userModule = loginUserData?.role?.module ?? null;
  const bsRouteConfig = [
    {
      path: "/bs/dashboard",
      element: <BenchSalesDashboard />,
      id: "dashboard",
    },

    {
      path: "/bs/benchsales/candidates",
      element: <Candidates />,
      id: "benchsaleshotlist",
    },

    // {
    //   key: "benchsaleshotlist_hotlist_addcandidates",
    //   path: "bs/benchsales/candidates/add-new-candidate",
    //   type: 1,
    //   children: [
    //     {
    //       key: "benchsaleshotlist_hotlist_addcandidate",
    //       path: "bs/benchsales/candidates/add-new-candidate",
    //       type: 1,
    //       children: [],
    //     },
    //   ],
    // },
    // {
    //   key: "benchsaleshotlist_hotlist_editcandidates",
    //   path: "bs/benchsales/candidates/edit-new-candidate",
    //   type: 1,
    //   children: [
    //     {
    //       key: "benchsaleshotlist_hotlist_editcandidate",
    //       path: "bs/benchsales/candidates/edit-new-candidate",
    //       type: 1,
    //       children: [],
    //     },
    //   ],
    // },
    {
      path: "/bs/benchsales/candidates/add-new-candidate",
      element: <CandidatesAddNewCandidate />,
      id: "benchsaleshotlist_hotlist_addcandidate",
    },
    {
      path: "/bs/benchsales/candidates/edit-new-candidate",
      element: <CandidatesAddNewCandidate />,
      id: "benchsaleshotlist_hotlist_editcandidate",
    },
    {
      path: "/bs/benchsales/jobs",
      element: <JobsBenchsales />,
      id: "benchsaleskultfetch",
    },

    // new added for submissions
    {
      path: "/bs/benchsales/submissions",
      element: <Submissions />,
      id: "benchsalessubmission",
    },
    {
      path: "/bs/benchsales/recruiters",
      element: <Recruiters />,
      id: "benchsalesrecruiters",
    },
    //new added interview

    {
      path: "/bs/benchsales/interview",
      element: <Interview />,
      id: "benchsalesinterview",
    },
    {
      path: "/bs/benchsales/placements",
      element: <Placement />,
      id: "benchsalesplacement",
    },
    {
      path: "/bs/benchsales/placements/push-to-workforce",
      element: <PushDataToWorkforceBs />,
      id: "benchsalesplacement",
    },
    {
      path: "/bs/benchsales/templates",
      element: <Templates />,
      id: "benchsalestemplate",
    },
    {
      path: "/bs/benchsales/hotlist",
      element: <Hotlist />,
      id: "benchsaleshotlist",
    },
    // {
    //   path: "/bs/benchsales/templates/clientemailtemplate",
    //   element: <ClientEmailTemplate />,
    //   id: "benchsalestemplate_clientemailtemplate",
    // },
    // {
    //   path: "/bs/benchsales/templates/candidateemailtemplate",
    //   element: <CandidateEmailTemplate />,
    //   id: "benchsalestemplate_candidateemailtemplate",
    // },
    {
      path: "/bs/benchsales/templates/resumetemplate",
      element: <ResumeTemplate />,
      id: "benchsalestemplate_resumetemplate",
    },

    { path: "/bs/help", element: <Help />, id: "help" },
    {
      path: "/bs/help/ticket-details",
      element: <TicketDetail />,
      id: "ticket_detail",
    },
    {
      path: "/bs/reports",
      element: <Reports />,
      id: "reports",
    },
    {
      path: "/bs/mail",
      element: <Mails />,
      id: "mails",
    },
  ];
  const accessibleRoutes = filterRoutes({
    routes: bsRouteConfig,
    modules: moduleAccess,
    role,
    accessKey: "benchsales",
    userModule,
    portal,
  });

  return (
    <>
      <Route
        element={
          <Suspense
            fallback={
              <Backdrop isOpen={true}>
                <LogoLoader />
              </Backdrop>
            }
          >
            <InnerMainLayoutBs />
          </Suspense>
        }
      >
        {accessibleRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
    </>
  );
};

export default BsRoutes;
